import { createFileRoute } from "@tanstack/react-router";
import { listSections } from "api-client";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibrarySectionsPage } from "src/pages/CoachLibrarySectionsPage";

export const SECTIONS_DEFAULT_PAGE_SIZE = 10;

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  sectionId: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_coach/library/sections/")({
  component: CoachLibrarySectionsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: (args) => {
    return {
      q: args.search.q,
      p: args.search.p,
      ps: args.search.ps,
    };
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const query = deps.q || "";
      const pageIndex = deps.p || 0;
      const pageSize = deps.ps || SECTIONS_DEFAULT_PAGE_SIZE;

      const sectionList = await listSections({
        query: {
          pageIndex,
          query,
          pageSize,
        },
      }).then((res) => {
        return res.data.data;
      });

      return {
        data: {
          sectionList,
          pageSize,
        },
      };
    });
  },
});
